import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logOut } from "../../../../slice/authSlice";
import { logoutUser } from "../../../../http/auth.service";
import { useSelector } from "react-redux";

function Logout() {
  const isLoggedIn = useSelector((data) => data.auth.logged);
  const dispatch = useDispatch();
  const _handleLogout = async () => {
    await logoutUser();
    dispatch(logOut());
    setTimeout(() => {
      window.location.replace("/");
    }, 1000);
  };

  useEffect(() => {
    if (isLoggedIn) {
      _handleLogout();
    } else {
      window.location.replace("/");
    }
  }, []);

  return (
    <div className="AddAgent main-parent">
      <div className="inner-wrapper">
        <div className="add-wrapper">
          <div class="d-flex align-items-center justify-content-center vh-100">
            <div class="text-center row"></div>
            <h1>Redirecting Back To Login Page...</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Logout;
